<template>
    <div>
        <el-table
            :data="data"
            height="300"
            stripe
            style="width: 100%">
            <el-table-column label="Nom de la fiche produit">
                <template slot="header" slot-scope="scope">
                    <selectCMSProvider 
                        style="max-width:300px"
                        :active="active"
                        :disabled="disabled"
                        :placeholder="placeholder"
                        @selected="handleSelect"
                        />
                </template>
                <template slot-scope="props">
                    <span>{{ props.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column width="80">
                
                <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="danger"
                    circle
                    @click="handleDelete(scope.$index, scope.row)"><i class="mdi mdi-delete fs-12"></i></el-button>
            </template>
            </el-table-column>
        </el-table>
    </div>
  </template>
  <script>
  import selectCMSProvider from '@/views/pages/CMS/components/select-cms-provider';
  import cmsAPI from '@/services/API/cmsAPI';
  export default {
        name: 'SelectMultipleProviders',
        props: {
            active : {
                type : Boolean,
                default : true
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            showCMSName : {
                type: Boolean,
                default: false,
            },
            emptyText: {
                type: String,
                default: null
            },
            placeholder: {
                type: String,
                required: true
            },
            providers: {
                type: Array,
            }
      },
      data() {
          return {
                data: [],
                loading: false,
            }
     },
    computed: {
        myEmptyText(){
            if (this.emptyText == null) {
                return this.$i18n.t('common.table.empty');
            }
            return this.emptyText
        },
    },
    components : {
        selectCMSProvider,
    },
    methods : {
        fetchProviders(){
            this.loading = true;
            const ids = _.map(this.providers, provider => (provider.id));
            if (!_.isEmpty(ids)) {
                return cmsAPI.fetchCMSProviders({ id: ids, paging:'no' })
                    .then((providers) => {
                        this.data.splice(0, this.data.length);
                        this.data.push(...providers);
                        this.loading = true;
                    }).catch((err) => {
                        this.loading = false;
                    })
            } else {
                this.loading= false;
            } 
        },
        handleDelete(index, value) {
            this.data.splice(index,1);
            this.$emit('change', this.data);
        },
        handleSelect (value) {
            if (value != null && value != '') {
                this.data.push(value);
            }
            this.$emit('change', this.data);
        },
        },
    watch: {
        providers: function() {
            return this.fetchProviders();
        }
    },
    created(){
    }
  }
  </script>
  <style lang="scss" scoped>
  
  </style>
  